import { Record, List } from 'immutable';

// type rawCategories = Array<{|
//   id: string,
//   parent_id: string,
// |}>

// factories
export const CategoriesStoreFactory = new Record({
  list: new List(),
});

export const CategoryFactory = new Record({
  id: null,
  parent_id: null,
  left: 0,
  right: 0,
  name: '',
  nameLangId: '',
  level: 1,
  count: 0,
  icon: null,
  children: List(),
  parentList: List(),
  documentMovable: false,
  order: null,
  // DA-19682: hidden Financial/General doctype-tab children of this category, as
  // [{ name_id: 'all' | 'financial' | 'general', id }] (no count), or null when the category
  // owns none. `id` is the category id to route to for that tab — powers in-session document-type
  // persistence (da-19295 D10). Kept as the raw array; consumers read it via cat.tabs.
  tabs: null,
});

// adapters
export const categoriesStoreAdapter = (categories) => {
  const list = List(categories.map((category) => CategoryFactory(category)));
  return CategoriesStoreFactory({
    list,
  });
};
